import { Box, IconButton } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

export const CloseButton: React.FunctionComponent<{ onClose: () => void }> = function ({
    onClose,
}) {
    return (
        <Box sx={{ position: 'absolute', right: '10px', top: '0px' }}>
            <IconButton
                color="inherit"
                onClick={onClose}
                aria-label="close"
                sx={{ margin: '10px' }}
            >
                <CloseIcon />
            </IconButton>
        </Box>
    );
};
